import React, { useState, useEffect } from "react";
import { Row, Col, Card, Tag, Descriptions, Button, Tabs, Avatar, Modal, Spin, Typography } from "antd";
import { useParams, Link } from "react-router-dom";
import { UserOutlined, CarOutlined, FileTextOutlined, ArrowRightOutlined } from "@ant-design/icons";
import axios from "axios";

const { TabPane } = Tabs;
const { Title } = Typography;

const ReservationDetail = () => {
  const { id } = useParams();
  const [reservation, setReservation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  useEffect(() => {
    fetchReservationDetails();
  }, [id]);

  const fetchReservationDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`http://93.127.203.113:5005/reservation/${id}`);
      setReservation(response.data);
    } catch (error) {
      console.error("Failed to load reservation details:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderImage = (src, alt, placeholderIcon) => {
    const imageUrl = src ? `http://93.127.203.113:5005${src}` : null;

    return imageUrl ? (
      <img
        src={imageUrl}
        alt={alt}
        style={{
          width: "100%",
          height: "300px",
          objectFit: "cover",
          cursor: "pointer",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
        onClick={() => {
          setPreviewImage(imageUrl);
          setPreviewVisible(true);
        }}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = null; // Fallback to placeholder if image fails to load
        }}
      />
    ) : (
      <Avatar
        shape="square"
        icon={placeholderIcon}
        style={{
          width: "100%",
          height: "300px",
          borderRadius: "10px",
          backgroundColor: "#f0f2f5",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      />
    );
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <Spin size="large" />
      </div>
    );
  }

  const { passenger, vehicle, customer_agreement: agreement } = reservation || {};

  return (
    <div style={{ padding: "20px" }}>
      <Card
        style={{
          marginBottom: "20px",
          borderRadius: "10px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          borderTop: "5px solid #0c8c49",
        }}
      >
        <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
          Reservation Details
        </Title>
        <Tabs defaultActiveKey="1" type="card" tabBarStyle={{ color: "#aa0077" }}>
          <TabPane tab={<span><ArrowRightOutlined /> Overview</span>} key="1">
            <Descriptions bordered column={2} style={{ marginBottom: "20px" }}>
              <Descriptions.Item label="Reservation ID">{reservation?.id || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Price">${reservation?.price || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Status">
                <Tag color={
                  reservation?.status === "confirmed"
                    ? "#0c8c49"
                    : reservation?.status === "pending"
                    ? "#aa0077"
                    : "red"
                }>
                  {reservation?.status?.toUpperCase() || "N/A"}
                </Tag>
              </Descriptions.Item>
              <Descriptions.Item label="Start Date">
                {reservation?.startDate ? new Date(reservation.startDate).toLocaleString() : "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="End Date">
                {reservation?.endDate ? new Date(reservation.endDate).toLocaleString() : "N/A"}
              </Descriptions.Item>
            </Descriptions>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Title level={5} style={{ color: "#aa0077" }}>Vehicle</Title>
                {renderImage(vehicle?.vehicleImage, "Vehicle Image", <CarOutlined />)}
              </Col>
            </Row>
          </TabPane>

          <TabPane tab={<span><UserOutlined /> Passenger</span>} key="2">
            <Card
              title="Passenger Info"
              extra={
                <Link to={`/passengerDetails/${passenger?.id}`}>
                  <Button type="link" style={{ color: "#0c8c49" }}>
                    View Details
                  </Button>
                </Link>
              }
              bordered={false}
              style={{ borderRadius: "10px", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}
            >
              <Descriptions bordered column={1}>
                <Descriptions.Item label="Name">
                  {`${passenger?.firstName || "N/A"} ${passenger?.lastName || ""}`}
                </Descriptions.Item>
                <Descriptions.Item label="Phone">{passenger?.phoneNumber || "N/A"}</Descriptions.Item>
              </Descriptions>
            </Card>
          </TabPane>

          <TabPane tab={<span><CarOutlined /> Vehicle</span>} key="3">
            <Card
              title="Vehicle Info"
              extra={
                <Link to={`/vehicleDetails/${vehicle?.id}`}>
                  <Button type="link" style={{ color: "#0c8c49" }}>
                    View Details
                  </Button>
                </Link>
              }
              bordered={false}
              style={{ borderRadius: "10px", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}
            >
              <Descriptions bordered column={1}>
                <Descriptions.Item label="Plate">{vehicle?.plateNumber || "N/A"}</Descriptions.Item>
                <Descriptions.Item label="Model">{vehicle?.model || "N/A"}</Descriptions.Item>
                <Descriptions.Item label="Color">{vehicle?.color || "N/A"}</Descriptions.Item>
                <Descriptions.Item label="Year">{vehicle?.manufacturedYear || "N/A"}</Descriptions.Item>
              </Descriptions>
            </Card>
          </TabPane>

          {/* <TabPane tab={<span><FileTextOutlined /> Agreement</span>} key="4">
            <Card
              title={`Agreement #${agreement?.agreementId}`}
              extra={
                <Link to={`/agreementDetails/${agreement?.agreementId}`}>
                  <Button type="link" style={{ color: "#0c8c49" }}>
                    View Details
                  </Button>
                </Link>
              }
              bordered={false}
              style={{ borderRadius: "10px", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}
            >
              <Descriptions bordered column={1}>
                <Descriptions.Item label="Price/Day">${agreement?.pricePerDay || "N/A"}</Descriptions.Item>
                <Descriptions.Item label="Start">
                  {agreement?.startDate ? new Date(agreement.startDate).toLocaleString() : "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="End">
                  {agreement?.endDate ? new Date(agreement.endDate).toLocaleString() : "N/A"}
                </Descriptions.Item>
              </Descriptions>
            </Card>
          </TabPane> */}
        </Tabs>
      </Card>

      <Modal
        visible={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        centered
      >
        <img alt="Preview" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </div>
  );
};

export default ReservationDetail;
